const isiOS = () => {
    return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
            navigator.platform,
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
};

const isMacOS = () => {
    return typeof navigator !== 'undefined' ? /Mac/.test(navigator.userAgent) : false;
};

const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

const isAndroid = () => {
    return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
};

export { isAndroid, isiOS, isMacOS, isSafari };
